<template>
  <div class="custom_title">
    <slot> &nbsp; </slot>
  </div>
</template>

<script setup></script>

<style scoped>
.custom_title {
  color: #555;
  font-size: 24px;
  font-weight: bold;
}
</style>
